import { render, staticRenderFns } from "./summit.vue?vue&type=template&id=155bc782&scoped=true"
import script from "./summit.vue?vue&type=script&lang=js"
export * from "./summit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155bc782",
  null
  
)

export default component.exports